// import process from "process";
// import { config as configDotenv } from "dotenv";
// import { resolve } from "path";

const getUrls = () => {
  //console.log(process.env.MODE);
  //console.log(process.env.REACT_APP_BACKEND_URL);
};

export default getUrls;
